import { useMemo } from 'react';
import {
    PROMOTE_SHOWS_COUNT_ADVERTISING_MENU_KEY,
    PROMOTE_SHOWS_COUNT_ADVERTISING_POST_KEY,
    PROMOTE_SHOWS_COUNT_ADVERTISING_PROFILE_KEY,
} from '../ui/constants';
import { getWindow } from './getWindow';

const MAX_PROMO_SHOWS_COUNT = 3;

const usePromoEnabled = (key: string, maxShowsCount: number) => {
    const LS = getWindow()?.localStorage;

    if (!LS) {
        return true;
    }

    const promoShowsCount = parseInt(LS.getItem(key) || '0', 10);

    return promoShowsCount < maxShowsCount;
};

const updatePromoEnabled = (key: string, maxShowsCount: number) => {
    const LS = getWindow()?.localStorage;

    if (!LS) {
        return;
    }

    const promoShowsCount = parseInt(LS.getItem(key) || '0', 10);

    if (promoShowsCount > maxShowsCount) {
        return;
    }

    getWindow()?.localStorage?.setItem(key, String(promoShowsCount + 1));
};

const disablePromo = (key: string, maxShowsCount: number) => {
    const LS = getWindow()?.localStorage;

    if (!LS) {
        return;
    }

    LS?.setItem(key, String(maxShowsCount + 1));
};

export const useAdvertisingMenuPromoEnabled = () =>
    useMemo(
        () => usePromoEnabled(PROMOTE_SHOWS_COUNT_ADVERTISING_MENU_KEY, MAX_PROMO_SHOWS_COUNT),
        [],
    );

export const useAdvertisingPostPromoEnabled = () =>
    useMemo(
        () => usePromoEnabled(PROMOTE_SHOWS_COUNT_ADVERTISING_POST_KEY, MAX_PROMO_SHOWS_COUNT),
        [],
    );

export const useAdvertisingProfilePromoEnabled = () =>
    useMemo(() => usePromoEnabled(PROMOTE_SHOWS_COUNT_ADVERTISING_PROFILE_KEY, 1), []);

export const updateAdvertisingMenuPromoEnabled = () =>
    updatePromoEnabled(PROMOTE_SHOWS_COUNT_ADVERTISING_MENU_KEY, MAX_PROMO_SHOWS_COUNT);

export const updateAdvertisingPostPromoEnabled = () =>
    updatePromoEnabled(PROMOTE_SHOWS_COUNT_ADVERTISING_POST_KEY, MAX_PROMO_SHOWS_COUNT);

export const disableAdvertisingMenuPromoEnabled = () =>
    disablePromo(PROMOTE_SHOWS_COUNT_ADVERTISING_MENU_KEY, MAX_PROMO_SHOWS_COUNT);

export const disableAdvertisingPostPromoEnabled = () =>
    disablePromo(PROMOTE_SHOWS_COUNT_ADVERTISING_POST_KEY, MAX_PROMO_SHOWS_COUNT);

export const disableAdvertisingProfilePromoEnabled = () =>
    disablePromo(PROMOTE_SHOWS_COUNT_ADVERTISING_PROFILE_KEY, 1);
